export default __webpack_public_path__ + "static/flipkart-thumbnail-c716650c3c3c97c449973c649e618366.png";